import iconEventPlanning from "../assets/images/Home/Icon Event Planning 250_250 - 1.webp";
import iconWeddingEvent from "../assets/images/Home/Icon Wedding Event 250_250 - 2.webp";
import iconCorporateEvent from "../assets/images/Home/Icon Corporate Event 250_250 - 4.webp";
import iconPrePostEvent from "../assets/images/Home/Icon Pre-Post Event 250_250 - 1.webp";
import iconBrandActivities from "../assets/images/Home/Icon Brand Activities 250_250 - 1.webp";
import iconBirthdayParty from "../assets/images/Home/Icon Birthday Party 250_250 - 2.webp";
import iconAnniversary from "../assets/images/Home/Icon Anniversary 250_250 - 3.webp";
import iconVenueSelection from "../assets/images/Home/Icon Venue Selection 250_250 - 2.webp";
import iconEventDesign from "../assets/images/Home/Icon Event Design 250_250 - 2.webp";
import iconSocialActivities from "../assets/images/Home/Icon Social Activities 250_250 - 1.webp";
import iconEventConcept from "../assets/images/Home/Icon Event Concept 250_250 - 6.webp";
import iconBudgetManagement from "../assets/images/Home/Icon Budget Management  250_250 - 4.webp";
import iconCustomDesign from "../assets/images/Home/Icon Custom Design  250_250 - 2.webp";
import iconDecor from "../assets/images/Home/Icon Decor  250_250 - 2.webp";
import iconAVEquipments from "../assets/images/Home/Icon AV Equipments  250_250 - 3.webp";
import iconPhotoVideographer from "../assets/images/Home/Icon Photo & Videographer 250_250 - 1.webp";
import iconCatering from "../assets/images/Home/Icon Catering 250_250 - 1.webp";
import iconEntryConcept from "../assets/images/Home/Icon Entry Concept 250_250 - 3.webp";
import iconArtistManagement from "../assets/images/Home/Icon Artist Management  250_250 - 4.webp";
import iconOnGroundCoordinator from "../assets/images/Home/Icon On Ground Event Coordinator 250_250 - 2.webp";
import iconThemeDecor from "../assets/images/Home/Icon Theme Decor  250_250 - 2.webp";
import iconLightSetup from "../assets/images/Home/Icon Light Setup 250_250 - 1.webp";
import iconSFX from "../assets/images/Home/Icon SFX 250_250 - 9.webp";
import iconManpower from "../assets/images/Home/Icon Manpower 250_250 - 2.webp";
import iconCarnivalZone from "../assets/images/Home/Icon Carnival Zone  250_250 - 1.webp";
import iconStageLayout from "../assets/images/Home/Icon Stage Layout  250_250 - 5.webp";
import iconStallDecor from "../assets/images/Home/Icon Stall Decor  250_250 - 4.webp";
import iconBranding from "../assets/images/Home/Icon Branding  250_250 - 6.webp";
import iconSpecialEffect from "../assets/images/Home/Icon Special Effect 250_250 - 2.webp";
import iconPhotobooth from "../assets/images/Home/Icon Photobooth 250_250 - 6.webp";
import iconInvitationCard from "../assets/images/Home/Icon Invitation Card 250_250 - 6.webp";
import iconVirtualEvent from "../assets/images/Home/Icon Virtual Event 250_250 - 5.webp";
import iconVendorCoordination from "../assets/images/Home/Icon Vender Coordination 250_250 - 4.webp";
import iconGuestManagement from "../assets/images/Home/Icon Guest Management 250_250 - 4.webp";
import iconHouseEvent from "../assets/images/Home/Icon House Event 250_250 - 8.webp";
import iconEndToEnd from "../assets/images/Home/Icon End To End Event Planning 250_250 - 5.webp";

/** Display order matches Services section; each chip shows icon + title */
export const SERVICES_CHIPS = [
  { title: "Event Planning", icon: iconEventPlanning },
  { title: "Wedding Event", icon: iconWeddingEvent },
  { title: "Corporate Event", icon: iconCorporateEvent },
  { title: "Pre-Post Event", icon: iconPrePostEvent },
  { title: "Brand activities", icon: iconBrandActivities },
  { title: "Birthday Party", icon: iconBirthdayParty },
  { title: "Anniversary", icon: iconAnniversary },
  { title: "Venue Selection", icon: iconVenueSelection },
  { title: "Event Design", icon: iconEventDesign },
  { title: "Social Activities", icon: iconSocialActivities },
  { title: "Event Concept", icon: iconEventConcept },
  { title: "Budget Management", icon: iconBudgetManagement },
  { title: "Custom Design", icon: iconCustomDesign },
  { title: "Decor", icon: iconDecor },
  { title: "AV Equipments", icon: iconAVEquipments },
  { title: "Photo & Videographer", icon: iconPhotoVideographer },
  { title: "Catering", icon: iconCatering },
  { title: "Entry Concept", icon: iconEntryConcept },
  { title: "Artist Management", icon: iconArtistManagement },
  { title: "On Ground Event Coordinator", icon: iconOnGroundCoordinator },
  { title: "Theme Decor", icon: iconThemeDecor },
  { title: "Light Setup", icon: iconLightSetup },
  { title: "SFX", icon: iconSFX },
  { title: "Man Power", icon: iconManpower },
  { title: "Carnival Zone", icon: iconCarnivalZone },
  { title: "Stage Layout", icon: iconStageLayout },
  { title: "Stall Decor", icon: iconStallDecor },
  { title: "Branding", icon: iconBranding },
  { title: "Special Effect", icon: iconSpecialEffect },
  { title: "Photobooth", icon: iconPhotobooth },
  { title: "Invitation Cards", icon: iconInvitationCard },
  { title: "Virtual Event", icon: iconVirtualEvent },
  { title: "Vendor Coordination", icon: iconVendorCoordination },
  { title: "Guest Management", icon: iconGuestManagement },
  { title: "House Events", icon: iconHouseEvent },
  { title: "End To End Event Planning", icon: iconEndToEnd },
];
